import { css } from 'styled-components';

const variables = css`
  :root {
    /* Backgrounds - Deep Slate Black */
    --dark-navy: #0f172a;       /* Main background */
    --navy: #1e293b;            /* Slightly lighter (cards/sections) */
    --light-navy: #334155;      /* Header/Nav background */
    --lightest-navy: #475569;   /* Hover states for containers */
    --navy-shadow: rgba(2, 6, 12, 0.7);

    /* Text - Off-White and Muted Slates */
    --dark-slate: #64748b;
    --slate: #94a3b8;           /* Secondary text / Paragraphs */
    --light-slate: #cbd5e1;
    --lightest-slate: #f1f5f9;  /* Primary text / Headings */
    --white: #ffffff;

    /* Accents - Electric Blue */
    --green: #38bdf8;           /* Primary Accent */
    --green-tint: rgba(56, 189, 248, 0.1);
    --pink: #7dd3fc;            /* Lighter blue for subtle variety */
    --blue: #38bdf8;

    /* Typography */
    --font-sans: 'Inter', 'Calibre', 'San Francisco', 'SF Pro Text', -apple-system, system-ui,
      sans-serif;
    --font-mono: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;

    --fz-xxs: 12px;
    --fz-xs: 13px;
    --fz-sm: 14px;
    --fz-md: 16px;
    --fz-lg: 18px;
    --fz-xl: 20px;
    --fz-xxl: 22px;
    --fz-heading: 32px;

    /* Layout & Styling */
    --border-radius: 4px; /* Slightly increased for a more modern feel */
    --nav-height: 70px;
    --nav-scroll-height: 60px;

    --tab-height: 42px;
    --tab-width: 120px;

    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    --hamburger-width: 30px;

    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out,
      transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }
`;

export default variables;